import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { MFA_SELECT_CHANNEL_PAGE_NAME } from './constants';
import FormElement from '../FormElement';
import MFAChannelButton from './MFAChannelButton';
import AnalyticsDataLayer from '../Analytics';

function MFASelectChannel(props) {
  const requestInProgress = useSelector((state) => state.mfa.requestInProgress);
  const { channels, onSelectChannel, url } = props;
  return (
    <>
      <AnalyticsDataLayer pageName={MFA_SELECT_CHANNEL_PAGE_NAME} />
      {channels.map((channel) => (
        <FormElement key={channel.value}>
          <MFAChannelButton
            id={channel.type}
            type={channel.type}
            maskedValue={channel.maskedValue}
            isLoading={requestInProgress[channel.type]}
            onClick={() => onSelectChannel(channel)}
            url={url}
          />
        </FormElement>
      ))}
    </>
  );
}

MFASelectChannel.propTypes = {
  channels: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
      maskedValue: PropTypes.number.isRequired,
    }),
  ),
  onSelectChannel: PropTypes.func.isRequired,
};

MFASelectChannel.defaultProps = {
  channels: [],
};

export default MFASelectChannel;
